import InsuranceArticleSidebar from './InsuranceArticleSidebar';
import { HO4_ARTICLE_CATEGORIES } from '../data/ho4Articles';

type Ho4ArticleSidebarProps = {
  activeHref?: string;
  onNavigate: (href: string) => void;
};

function Ho4ArticleSidebar({ activeHref, onNavigate }: Ho4ArticleSidebarProps) {
  return (
    <InsuranceArticleSidebar
      sidebarTitle="HO-4 / Renter's Insurance"
      categories={HO4_ARTICLE_CATEGORIES}
      activeHref={activeHref}
      onNavigate={onNavigate}
      defaultOpenCategory="Fundamentals"
    />
  );
}

export default Ho4ArticleSidebar;
